// ----------------------------------------------------------------------------
// Snippet: Cart Confirmation
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/modal/modal';
import 'snippets/mini-cart/mini-cart';

// Styles
import './_cart-confirmation.scss';

const SELECTORS = {
  CART_ITEM: '.cart-confirmation__item',
  SALE_PRICE: '.card__price--sale',
  ORIGINAL_PRICE: '.card__price--original'
};

const extractPrice = (element) => {
  return parseFloat(element.textContent.replace('$', ''));
};

const handlePriceDisplay = (cartItem) => {
  const salePriceElement = cartItem.querySelector(SELECTORS.SALE_PRICE);
  const originalPriceElement = cartItem.querySelector(SELECTORS.ORIGINAL_PRICE);

  if (!salePriceElement || !originalPriceElement) return;

  const originalPrice = extractPrice(originalPriceElement);
  const salePrice = extractPrice(salePriceElement);

  if (originalPrice >= salePrice) {
    salePriceElement.style.display = 'none';
  }
};

const observeCartConfirmation = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.classList.contains(SELECTORS.CART_ITEM.slice(1))) {
        handlePriceDisplay(mutation.target);
      }
    });
  });

  const cartItems = document.querySelectorAll(SELECTORS.CART_ITEM);
  
  cartItems.forEach(item => {
    observer.observe(item, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true
    });
  });
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', observeCartConfirmation);

export { observeCartConfirmation };